export class AreaFilter {
  text:string = '';
  active:string = 'active';
  constructor() {}
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/components/areas/list/areaFilter.ts